import { ReactNode } from 'react';

import { cn } from '@app/shared/utils/common';

export interface FieldWithLabelProps {
  label: string;
  className?: string;
  children: ReactNode;
  error?: string;
  hasErrorField?: boolean;
}

export function FieldWithLabel({
  label,
  className,
  children,
  error,
  hasErrorField,
}: FieldWithLabelProps) {
  return (
    <div
      className={cn('flex flex-col gap-1 text-sm font-medium', !hasErrorField && 'mb-5', className)}
    >
      <div className="flex flex-col gap-2">
        {label}
        {children}
      </div>

      {hasErrorField && <span className="text-xs text-red-500">{error || '\u00A0'}</span>}
    </div>
  );
}
